import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeFormat',
    standalone: false
})
export class TimeFormatPipe implements PipeTransform {
  transform(seconds: number | null | undefined): string {
    if (seconds == null || seconds < 0) {
      return '0 сек';
    }

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds} сек`;
    }

    return `${minutes} мин ${remainingSeconds} сек`;
  }
}